// const BASE_PROXY_URL = "https://api.jigyaasu.ai"; // production URL
const BASE_PROXY_URL = "https://api.dhootschool.jigyaasu.ai";
// const BASE_PROXY_URL = "http://192.168.1.32:8000"; // development URL

// export const BASE_IMAGE_URL = "https://api.jigyaasu.ai";
export const BASE_IMAGE_URL = "https://api.dhootschool.jigyaasu.ai";
// export const BASE_IMAGE_URL = "http://192.168.1.32:8000";

// AUTHENTICATION
export const POST_LOGIN = `${BASE_PROXY_URL}/api/login`;
export const POST_SIGNUP = `${BASE_PROXY_URL}/api/signup`;
export const GOOGLE_SIGNUP = `${BASE_PROXY_URL}/api/auth/google/login`;
export const GET_USER_LIST = `${BASE_PROXY_URL}/api/all-user-details`;
export const COOKIE_EXPIRE = `${BASE_PROXY_URL}/api/current-user`;
export const POST_CHANGE_PASSWORD = `${BASE_PROXY_URL}/api/user/change-password`;
export const POST_FORGOT_PASSWORD = `${BASE_PROXY_URL}/api/forgot-password`;
export const PATCH_RESET_PASSWORD = `${BASE_PROXY_URL}/api/reset-password`;

//PROFILE
export const POST_EDIT_PROFILE = `${BASE_PROXY_URL}/api/profile-details`;
export const GET_PROFILE_DETAILS = `${BASE_PROXY_URL}/api/all-user-details`;
export const GET_PROFILE_PERCENTAGE = `${BASE_PROXY_URL}/api/profile-percentage`;

//NOTIFICATION
export const GET_NOTIFICATION = `${BASE_PROXY_URL}/api/student/notifications`;

// RESOURCE
export const POST_UPLOAD_PDF_FILE = `${BASE_PROXY_URL}/api/common-upload`;
export const GET_UPLOADED_RESOURCE = `${BASE_PROXY_URL}/api/materials`;
export const GET_PDF_META_DATA = `${BASE_PROXY_URL}/api/pdf-metadata`;
export const GET_PDF_LISTS = `${BASE_PROXY_URL}/api/pdfs`;
export const DELETE_PDF_LIST = `${BASE_PROXY_URL}/api/delete-file`;
export const GET_PDF_URL = `${BASE_PROXY_URL}/api/files`;
// export const GET_COVER_IMAGE_URL = `${BASE_PROXY_URL}/api//materials`;
export const DELETE_RESOURCE = `${BASE_PROXY_URL}/api/teacher/delete-materials`;

// CODING
export const POST_PROBLEM_STATEMENT = `${BASE_PROXY_URL}/api/coding-exercise`;
export const POST_SUGGESTION = `${BASE_PROXY_URL}/api/suggest-code`;
export const POST_SUBMIT_CODE = `${BASE_PROXY_URL}/api/submit`;
export const POST_UPLOAD_CODE_FILE = `${BASE_PROXY_URL}/api/code-upload`;
export const GET_LANGUAGES = `${BASE_PROXY_URL}/api/languages`;
export const GET_LANGUAGE_CATEGORY = `${BASE_PROXY_URL}/api/language_categories`;
export const GET_LANGUAGE_LEVELS= `${BASE_PROXY_URL}/api/language_levels`;
export const GET_SUB_LEVELS= `${BASE_PROXY_URL}/api/language_levels`;
export const POST_RUN_CODE= `${BASE_PROXY_URL}/api/run-code`;
export const GET_CODING_STATS = `${BASE_PROXY_URL}/api/coding-exercises/stats`;
export const POST_HINT = `${BASE_PROXY_URL}/api/suggest-code`;

// TEST
export const POST_GENERATE_QUESTIONS = `${BASE_PROXY_URL}/api/generate-qa`;
export const POST_GENERATE_TEST_RESULTS = `${BASE_PROXY_URL}/api/answer-questions`;
export const POST_GENERATE_CORRECT_ANSWERS = `${BASE_PROXY_URL}/api/compare-answers`;
export const GET_SUBJCET_CHAPTER = `${BASE_PROXY_URL}/api/materials/subject/chapter`;
export const GET_ASSESSMENT_HISTORY = `${BASE_PROXY_URL}/api/assignment-history`;
export const GET_ASSIGNMENT_HISTORY_NOT_ATTEMPTED = `${BASE_PROXY_URL}/api/assignment-history/not-attempted`;
export const GET_FUTURE_ASSESSMENT = `${BASE_PROXY_URL}/api/student/upcoming-assignments`;
export const POST_FUTURE_ASSESSMENT_QUESTIONS = `${BASE_PROXY_URL}/api/student/start-test`;
export const GET_SUBMISSION_DATA = `${BASE_PROXY_URL}/api/student/resume_test`;
export const POST_SUBMIT_TEST = `${BASE_PROXY_URL}/api/student/submit`;
export const GET_SHOW_TEST_RESULT = `${BASE_PROXY_URL}/api/student/result`;
export const GET_ASSIGNMENT_IN_PROGRESS = `${BASE_PROXY_URL}/api/student/assignments/in-progress`;

// CHAT
export const POST_TYPE_CHAT = `${BASE_PROXY_URL}/api/aira-audio`;
export const POST_CHAT_HISTORY = `${BASE_PROXY_URL}/api/aira-chat/sessions`;
export const POST_AIRA_SPEAKER = `${BASE_PROXY_URL}/api/aira-speaker`;
export const POST_AIRA_AUDIO = `${BASE_PROXY_URL}/api/aira-audio`;

//FLASHCARDS
export const POST_GENERATE_FLASHCARDS = `${BASE_PROXY_URL}/api/generate-flashcard`;

//TEACHER RESOURCE
export const POST_CREATE_RESOURCE = `${BASE_PROXY_URL}/api/common-upload`;
export const GET_ASSIGNMENT_HISTORY = `${BASE_PROXY_URL}/api/fetch-all-assignments`;
export const POST_CREATE_ALL_ASSIGNMENT_HISTORY = `${BASE_PROXY_URL}/api/teacher/assign-assignment`;
export const DELETE_QUIZ_ASSIGNMENT = `${BASE_PROXY_URL}/api/teacher/delete-assignment`;
export const UPDATE_QUIZ_ASSIGNMENT = `${BASE_PROXY_URL}/api/teacher/update-assignment-details`;
export const POST_GENERATE_CAT_PAPER = `${BASE_PROXY_URL}/api/teacher/generate-cat-paper`;
// export const POST_FINALIZE_CAT_PAPER = `${BASE_PROXY_URL}/api/teacher/generate-cat-paper`;
export const GET_REPORT_DATA = `${BASE_PROXY_URL}/api/teacher/report-analysis`;
export const GET_ALL_ASSESSMENT_DATA = `${BASE_PROXY_URL}/api/teacher/get_assignment_metadata`;


// ANALYTICS
export const GET_ANALYTICS_REPORT = `${BASE_PROXY_URL}/api/assignment-report`;

//ADMIN
export const POST_UPLOAD_CSV = `${BASE_PROXY_URL}/api/admin/upload-users-csv`;
export const GET_UPLOADED_CSV_DATA = `${BASE_PROXY_URL}/api/admin/all-users-information`;
export const REACTIVATE_USER = `${BASE_PROXY_URL}/api/admin/reactivate-user`;
export const DEACTIVATE_USER = `${BASE_PROXY_URL}/api/admin/deactivate-user`;
export const PATCH_EDIT_USER = `${BASE_PROXY_URL}/api/admin/update-user`;
export const POST_ADD_USER = `${BASE_PROXY_URL}/api/admin/create-user`;
export const PATCH_CHANGE_ROLE = `${BASE_PROXY_URL}/api/admin/change-role-with-profile`;
export const GET_ADMIN_REPORT = `${BASE_PROXY_URL}/api/admin/admin-report`;
export const PATCH_MULTIPLE_STATUS_UPDATE = `${BASE_PROXY_URL}/api/admin/update-multiple-user-status`;


